var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.success)?_c('span',{staticClass:"text-color-secondary font-semi-bold p-1"},[_c('img',{staticClass:"mr-1",attrs:{"src":_vm.icoCircleChecked,"alt":"paid"}}),_vm._v(_vm._s(_vm.text))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }